<template>
  <div>

    <v-card
        class="rounded-lg white" flat
    >
      <v-card-title class=" mr-3 mt-3 secondary--text">
        <v-img class="ml-3" src="/img/icons/last_accounts.svg" max-width="25" max-height="25"></v-img>
        آخرین حساب های تعریف شده
        <v-spacer></v-spacer>
        <v-tooltip right >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" fab icon class="mr-3" href="accounts/0">
              <v-img class="" src="/img/icons/info_circle.svg" max-width="23"></v-img>
            </v-btn>
          </template>
          مشاهده کامل
        </v-tooltip>
      </v-card-title>
      <v-tabs class="rounded-lg white--text" v-model="openTab" background-color="secondary" active-class="primary" color="#FF8700">
        <v-tab class="white--text mr-5">
          <span >کل</span>
        </v-tab>
        <v-tab class="white--text">
          <span>معین</span>
        </v-tab>
        <v-tab class="white--text">
          <span>تفضیلی</span>
        </v-tab>
        <v-tab class="white--text">
          <span class>شناور</span>
        </v-tab>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  کد حساب
                </th>

                <th class="text-center">
                  نام حساب
                </th>
                <th class="text-center">
                  نوع
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="text-center">21312</td>
                <td class="text-center">مرشدی</td>
                <td class="text-center">sorooshMorshedi</td>
              </tr>
              <tr>
                <td class="text-center">67867 </td>
                <td class="text-center">رضایی</td>
                <td class="text-center">Ali2022Rezaee</td>
              </tr>
              <tr>
                <td class="text-center">378658</td>
                <td class="text-center">مسکن آقایی</td>
                <td class="text-center">sorooshMorshedi</td>
              </tr>
              <tr>
                <td class="text-center">4380 </td>
                <td class="text-center">تنخواه</td>
                <td class="text-center">Ali2022Rezaee</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  کد حساب
                </th>

                <th class="text-center">
                  نام حساب
                </th>
                <th class="text-center">
                  نوع
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="text-center">21312</td>
                <td class="text-center">مرشدی</td>
                <td class="text-center">sorooshMorshedi</td>
              </tr>
              <tr>
                <td class="text-center">67867 </td>
                <td class="text-center">رضایی</td>
                <td class="text-center">Ali2022Rezaee</td>
              </tr>
              <tr>
                <td class="text-center">378658</td>
                <td class="text-center">مسکن آقایی</td>
                <td class="text-center">sorooshMorshedi</td>
              </tr>
              <tr>
                <td class="text-center">4380 </td>
                <td class="text-center">تنخواه</td>
                <td class="text-center">Ali2022Rezaee</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-tab-item>
        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  کد حساب
                </th>

                <th class="text-center">
                  نام حساب
                </th>
                <th class="text-center">
                  نوع
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="text-center">21312</td>
                <td class="text-center">مرشدی</td>
                <td class="text-center">sorooshMorshedi</td>
              </tr>
              <tr>
                <td class="text-center">67867 </td>
                <td class="text-center">رضایی</td>
                <td class="text-center">Ali2022Rezaee</td>
              </tr>
              <tr>
                <td class="text-center">378658</td>
                <td class="text-center">مسکن آقایی</td>
                <td class="text-center">sorooshMorshedi</td>
              </tr>
              <tr>
                <td class="text-center">4380 </td>
                <td class="text-center">تنخواه</td>
                <td class="text-center">Ali2022Rezaee</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-tab-item>

        <v-tab-item class="pt-4">
          <v-simple-table class="mr-2 ml-2 rounded-b-lg">
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">
                  کد حساب
                </th>

                <th class="text-center">
                  نام حساب
                </th>
                <th class="text-center">
                  نوع
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td class="text-center">21312</td>
                <td class="text-center">مرشدی</td>
                <td class="text-center">sorooshMorshedi</td>
              </tr>
              <tr>
                <td class="text-center">67867 </td>
                <td class="text-center">رضایی</td>
                <td class="text-center">Ali2022Rezaee</td>
              </tr>
              <tr>
                <td class="text-center">378658</td>
                <td class="text-center">مسکن آقایی</td>
                <td class="text-center">sorooshMorshedi</td>
              </tr>
              <tr>
                <td class="text-center">4380 </td>
                <td class="text-center">تنخواه</td>
                <td class="text-center">Ali2022Rezaee</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-tab-item>
      </v-tabs>

    </v-card>
  </div>
</template>
<script>


export default {
  name: "LastAccounts",
  components: {
  },
  props: {
    id: {},
  },
  data() {
    return {
      openTab: null,
    }
  },
}
</script>

<style scoped lang="scss"></style>

